import script from "./RegisterView.vue?vue&type=script&setup=true&lang=ts"
export * from "./RegisterView.vue?vue&type=script&setup=true&lang=ts"

import "./RegisterView.vue?vue&type=style&index=0&id=28ccecdb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28ccecdb"]])

export default __exports__